import type { FC } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

export const ParcelTape: FC<SvgIconProps> = ({ viewBox = '0 0 255 169', ...props }) => (
  <SvgIcon viewBox={viewBox} fill="none" {...props} xmlns="http://www.w3.org/2000/svg">
    <path
      fill="url(#parcelTape_paint0_linear)"
      d="M131.037 145.832l9.765-1.746-17.498-8.675-9.624 1.718 17.357 8.703z"
      opacity=".6"
    />
    <path
      fill="url(#parcelTape_paint1_linear)"
      d="M171.507 138.537l33.669-3.746-21.336-6.619-25.258 4.985 12.925 5.38z"
      opacity=".6"
    />
    <path
      fill="url(#parcelTape_paint2_linear)"
      d="M79.22 134.369l25.231-4.986-42.813-21.238-25.259 4.986 42.842 21.238z"
      opacity=".6"
    />
    <path fill="#634509" d="M104.451 61.896l75.241-13.464-42.813-21.238-75.24 13.464 42.812 21.238z" />
    <path fill="#C39000" d="M81.648 28.462l75.24-13.464-20.009 12.196-75.24 13.464 20.009-12.196z" />
    <path
      fill="#996A0D"
      d="M167.387 62.346l12.305-13.914-42.813-21.238-12.334 13.887 42.842 21.265zM104.451 61.896l35.447.873L97.085 41.53l-35.447-.873 42.813 21.238z"
    />
    <path fill="#FDDE84" d="M104.451 61.896l75.241-13.464L162.335 31.7l-75.24 13.464 17.356 16.73z" />
    <path fill="#C39000" d="M104.451 61.896v67.487l-42.813-21.238V40.658l42.813 21.238z" />
    <path fill="#FCCE09" d="M104.451 61.896v67.487l75.241-13.464V48.432l-75.241 13.464z" />
    <path
      fill="#9E7549"
      d="M213.446 108.962a21.698 21.698 0 01-5.655 14.138 21.772 21.772 0 01-13.565 6.959 16.968 16.968 0 01-13.671-3.944 16.893 16.893 0 01-5.83-12.956 21.694 21.694 0 015.654-14.137 21.776 21.776 0 0113.565-6.96 16.966 16.966 0 0113.672 3.944 16.89 16.89 0 015.83 12.956z"
    />
    <path fill="#6B4C22" d="M194.283 133.354l-10.866-5.323 8.946-.366 1.92 5.689z" />
    <path fill="#9E7549" d="M203.737 93.64l10.358 5.07-7.479 2.281-2.879-7.352z" />
    <path
      fill="#BC9361"
      d="M223.38 113.948a21.693 21.693 0 01-5.744 14.109 21.776 21.776 0 01-13.617 6.875 16.971 16.971 0 01-13.595-3.993 16.904 16.904 0 01-4.314-5.819 16.862 16.862 0 01-1.479-7.088 21.69 21.69 0 015.744-14.11 21.778 21.778 0 0113.616-6.874 16.964 16.964 0 0113.595 3.992 16.898 16.898 0 015.794 12.908z"
    />
    <path
      fill="#E5E5E5"
      d="M218.892 114.426a16.657 16.657 0 01-4.413 10.836 16.724 16.724 0 01-10.46 5.276 13.082 13.082 0 01-10.431-3.119 13.032 13.032 0 01-4.442-9.922 16.658 16.658 0 014.414-10.836 16.724 16.724 0 0110.459-5.276 13.086 13.086 0 0110.431 3.119 13.036 13.036 0 014.442 9.922z"
    />
    <path
      fill="#C9C9C9"
      d="M193.267 106.934a16.74 16.74 0 0110.696-5.633 13.081 13.081 0 0110.431 3.119 13.04 13.04 0 014.442 9.922 15.025 15.025 0 01-.819 4.901"
    />
    <path
      fill="#fff"
      d="M206.023 111.047a9.53 9.53 0 00-1.512-5.232 9.557 9.557 0 00-4.132-3.556 17.148 17.148 0 00-7.62 5.436 15.754 15.754 0 00-3.556 9.802 13.469 13.469 0 00.931 5.07c1.548.582 3.21.794 4.855.619a12.507 12.507 0 007.794-4.008 12.458 12.458 0 003.24-8.131z"
    />
    <path fill="#9E7549" d="M140.801 144.086l39.681-7.154-16.341-8.817-40.837 7.296 17.497 8.675z" />
    <path
      fill="#9E7549"
      d="M187.622 127.862a8.657 8.657 0 01-3.979 7.858 13.659 13.659 0 01-3.217 1.212l-16.284-8.732 3.725-.761a7.96 7.96 0 007.027-3.83 9.93 9.93 0 00.424-5.634l12.304 9.887z"
    />
    <path fill="#EFEFEF" d="M71.855 149.747l31.75-5.689-31.468-15.52-31.778 5.69 31.496 15.519z" />
    <path
      fill="#000"
      fillRule="evenodd"
      d="M65.957 141.213l5.023 2.422 16.454-2.591-5.024-2.422-16.453 2.591zM52.156 134.566l4.233 2.084 16.454-2.591-4.262-2.056-16.425 2.563zM61.102 138.875l2.089 1.014 16.425-2.591-2.06-.986-16.454 2.563zM91.836 143.185l-2.117-.902-16.453 2.592 2.144 1.014 16.426-2.704zM58.675 137.72l.847.423 16.453-2.591-.847-.423-16.453 2.591z"
      clipRule="evenodd"
    />
    <defs>
      <linearGradient
        id="parcelTape_paint0_linear"
        x1="125.844"
        x2="128.629"
        y1="143.325"
        y2="137.885"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A1860E" stopOpacity="0" />
        <stop offset=".21" stopColor="#fff" stopOpacity="0" />
        <stop offset="1" />
      </linearGradient>
      <linearGradient
        id="parcelTape_paint1_linear"
        x1="177.107"
        x2="178.867"
        y1="134.986"
        y2="128.47"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".25" stopOpacity="0" />
        <stop offset=".599" stopOpacity=".3" />
        <stop offset="1" stopOpacity=".8" />
      </linearGradient>
      <linearGradient
        id="parcelTape_paint2_linear"
        x1="63.444"
        x2="70.23"
        y1="125.383"
        y2="110.87"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".25" stopOpacity="0" />
        <stop offset=".599" stopOpacity=".3" />
        <stop offset="1" stopOpacity=".8" />
      </linearGradient>
    </defs>
  </SvgIcon>
)
